import { useState } from 'react';
import styled from 'styled-components'
import TransitionAccordion from '../transition/TransitionAccordion';
import SidebarCollectionLink from './SidebarCollectionLink';
import SvgPlus from '../svg/SvgPlus';
import SvgMinus from '../svg/SvgMinus';

interface P {
  title: string
  links: any[]
  index: number
  activeIndex: number
  setActiveIndex: any
}

const SidebarCollectionLinks: React.FC<P> = ({
  title,
  links,
  index,
  activeIndex,
  setActiveIndex,
}: P) => {

  return (
    <Container>
      <Button onClick={() => setActiveIndex(index == activeIndex ? -1 : index)}>
        {title} 
        <span>
          {index == activeIndex ? 
            <SvgMinus /> 
          : 
            <SvgPlus />
          }
        </span>
      </Button>
      <TransitionAccordion isOpen={index == activeIndex}>
        <LinksWrap>
        <Links>
          {
            links.map((_link, index) => 
              <Link link={_link} key={`sidebarCollectionLinks__Link--${index}`}/>
            )
          }
          </Links>
        </LinksWrap>
      </TransitionAccordion>
    </Container>
  )
}


const Container = styled.div`
  margin-bottom: 8px;
 
  .collection-overlay-filter & {
    border-top: 1px solid var(--color-charcoal200);
    border-bottom: 1px solid var(--color-charcoal200);
    margin:-1px 0 0;
    padding-top: 4px;
    padding-bottom: 4px;
  }
`

const Button = styled.button`
  /* display: flex; */
  align-items: baseline;
  text-align: left;

  span {
    position: relative;
    margin-left:4px;
  }

  svg {
    left:0;
    position: absolute;
    display: inline-flex;
  }
`

const Link = styled(SidebarCollectionLink)`
  display: block;
`

const LinksWrap = styled.div`
  overflow: hidden;
  max-height: 100%;
`

const Links = styled.div`
  margin-top: var(--spacing-16);
  margin-bottom: var(--spacing-16);
`

export default SidebarCollectionLinks
